import type { MatrixResource } from '../../core/authorization/api';
import { toMask, type GrantState, type MatrixNode } from '../../core/authorization/permissionMatrix';

/** API tree → rules-engine nodes (masks instead of action-name arrays). */
export const nodesFor = (rows: MatrixResource[]): MatrixNode[] =>
  rows.map((r) => ({ ...r, supported: toMask(r.supported), grantMax: toMask(r.grantMax), children: nodesFor(r.children) }));

/** API tree → editable grant state (resourceId → mask). */
export const grantsFor = (rows: MatrixResource[]): GrantState =>
  Object.assign({}, ...rows.map((r) => ({ [r.resourceId]: toMask(r.granted), ...grantsFor(r.children) })));

export const titlesFor = (rows: MatrixResource[]): Record<string, string> =>
  Object.assign({}, ...rows.map((r) => ({ [r.resourceId]: r.title || r.label, ...titlesFor(r.children) })));

const AVATAR_COLORS = ['#b0124f', '#6b4bd8', '#1d6fb8', '#0f8a5f', '#a15c00', '#0e7490', '#be185d', '#4d7c0f'];

/** Stable colour per role, so a role keeps its colour between visits. */
export function roleColor(seed: string): string {
  let hash = 0;
  for (const ch of seed) hash = (hash * 31 + ch.charCodeAt(0)) | 0;
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export const initials = (name: string) =>
  name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase() || '?';

export type MatrixFilter = 'all' | 'granted' | 'ungranted' | 'changed';
